export enum PermissionType {
  User = "User",
  Group = "Group"
}
